var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('vb-modal',{attrs:{"vb_options":{
    id: _vm.modal_id,
    visible: true,
    no_close_on_backdrop: true,
    no_close_on_esc: true,
    hide_header_close: true,
    hide_header: true,
    hide_footer: true,
    centered: true,
    size: 'lg',
  }}},[_c('loader',{staticClass:"py-4 my-2",attrs:{"size":"large","show_timing_slot":true,"text_loading":_vm.messages,"text_footer":_vm.footer}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }